module.exports = __webpack_public_path__ + "img/hzhs8.9febabc8.jpg";